import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
const mutations = {

  [types.IMPORT_FILE_BEGIN](state) {
    state.importFileState = API_STATES.REQUEST_PENDING
  },
  [types.IMPORT_FILE_SUCCESS](state) {
    state.importFileError = null
    state.importFileState = API_STATES.REQUEST_SUCCESS
  },
  [types.IMPORT_FILE_ERROR](state, err) {
    state.importFileState = API_STATES.REQUEST_ERROR;
    state.importFileError = err;
  },

  [types.IMPORT_SIMPLE_FILE_BEGIN](state) {
    state.importScheduleFileState = API_STATES.REQUEST_PENDING
  },
  [types.IMPORT_SIMPLE_FILE_SUCCESS](state) {
    state.importScheduleFileError = null
    state.importScheduleFileState = API_STATES.REQUEST_SUCCESS
  },
  [types.IMPORT_SIMPLE_FILE_ERROR](state, err) {
    state.importScheduleFileState = API_STATES.REQUEST_ERROR;
    state.importScheduleFileError = err;
  },

};

export default mutations;
